<form #form="ngForm" class="motivo-perda-venda-concorrente-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Concorrentes
            </h6>
            <p class="form-text text-muted">
                Selecione em quais momentos este motivo deve ser exibido e ficar disponível para ser selecionado no cadastro de concorrentes
            </p>
        </div>
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.inativacaoConcorrente" name="inativacaoConcorrente" id="inativacaoConcorrente">
                    <label class="custom-control-label" for="inativacaoConcorrente">Inativação de concorrente</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo na inativação de um concorrente</p>
            </li>
        </ul>
    </div>
</form>
